<template>
  <a-form :form="form">
    <a-row>
      <a-row>
        <a-col :span="11">
          <a-form-item label="人力资源编码">
            <a-input v-decorator="[
    'code',
    { rules: [{ required: true, message: '请输入人力资源编码!' }, { max: 8, message: '长度最大8位，字段长度过长！' }] }]"
              placeholder="请输入人力资源编码!" />
          </a-form-item>
        </a-col>
        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="员工姓名">
            <a-input v-decorator="[
    'name',
    { rules: [{ required: true, message: '请输入姓名!' }, { max: 20, message: '长度最大20位，字段长度过长！' }] }]"
              placeholder="请输入姓名!" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="11">
          <a-form-item label="身份证号">
            <a-input v-decorator="[
    'idCard',
    {
      rules: [{ required: true, message: '请输入身份证号!' }, { max: 18, message: '长度最大18位，字段长度过长！' }, {
        validator: isValidIdNumber,
      }]
    }]" placeholder="请输入身份证号!" />
          </a-form-item>
        </a-col>
        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="手机号码">
            <a-input v-decorator="[
    'telNum',
    {
      rules: [{ required: true, message: '请输入手机号!' }, { max: 12, message: '长度最大12位，字段长度过长！' }, {
        validator: mobileValidator,
      }]
    },
  ]" @blur="mobileFocus" placeholder="请输入手机号" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item label="所属单位">
        <a-tree-select v-decorator="[
    'companyCode',
    { rules: [{ required: true, message: '请选择上级部门!' }] }]" show-search
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择部门" :tree-data="treeData"
          :treeDefaultExpandedKeys="expandedKeys" treeNodeFilterProp="title" @select="getXjDept">
        </a-tree-select>
      </a-form-item>

      <a-form-item label="所属部门">
        <a-select v-decorator="[
    'deptCode',
    { rules: [{ required: true, message: '请选择部门!' }] },
  ]" placeholder="请选择部门" style="width: 500px">
          <a-select-option v-for="item in deptList" :value="item.deptCode" :key="item.deptName">
            {{ item.deptName }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-row>
        <a-col :span="11">
          <a-form-item label="人员类型">
            <a-select v-decorator="[
    'workNature',
    { rules: [{ required: true, message: '请选择人员类型!' }] },
  ]" placeholder="请选择人员类型" style="width: 150px">
              <a-select-option value="自有">
                自有
              </a-select-option>
              <a-select-option value="外包">
                外包
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="性别">
            <a-select v-decorator="[
    'sex',
    { rules: [{ required: true, message: '请选择性别!' }] },
  ]" placeholder="请选择性别" style="width: 150px">
              <a-select-option value="男">
                男
              </a-select-option>
              <a-select-option value="女">
                女
              </a-select-option>
              <a-select-option value="其他">
                其他
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="11">
          <a-form-item label="员工在职状态">
            <a-select v-decorator="[
    'status',
    { rules: [{ required: true, message: '请选择在职状态!' }] },
  ]" placeholder="请选择在职状态" style="width: 150px">
              <a-select-option value="在职">
                在职
              </a-select-option>
              <a-select-option value="调离">
                调离
              </a-select-option>
              <a-select-option value="离职">
                离职
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="2">
        </a-col>
        <a-col :span="11">
          <a-form-item label="OA账号">
            <a-input style="width: 110px;" v-decorator="['oaNum', { rules: [{ required: false, message: '请输OA账号!' }] }]"
              placeholder="请输OA账号!" />
          </a-form-item>
        </a-col>
      </a-row>

    </a-row>
  </a-form>
</template>
<script>
import bus from "../../common/bus";
export default {
  props: {
    currdata: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sjDeptCode: {
      type: String,
      default: ''
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  data() {
    return {
      disabled: false,
      errorM: false,
      errorU: false,
      form: this.$form.createForm(this, { name: "empdetail_form" }),
      expandedKeys: [],
      deptList: []
    };
  },
  created() {
    bus.$on("ModalSubmitStaff", this.handleSubmit);
    //公共模块监听事件 ModalSubmit  并触发handleSubmit
  },
  mounted() {
    let currdata2 = {};
    if (this.currdata.dept_code) {
      currdata2.code = this.currdata.code;
      currdata2.deptCode = this.currdata.dept_code;
      currdata2.deptName = this.currdata.dept_name;
      this.expandedKeys = [this.currdata.dept_code];
      currdata2.oaNum = this.currdata.oanum;
      currdata2.telNum = this.currdata.tel_num;
      currdata2.name = this.currdata.name;
      currdata2.company = this.currdata.company;
      currdata2.companyCode = this.currdata.company_code;
      currdata2.workNature = this.currdata.work_nature;
      currdata2.sex = this.currdata.sex;
      currdata2.idCard = this.currdata.id_card;
      currdata2.createTime = this.currdata.create_time;
      currdata2.status = this.currdata.status;
      currdata2.accreditSatus = this.currdata.accredit_status;
    }
    this.form.setFieldsValue(currdata2);
    if (this.currdata.dept_code) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }

    this.getXjDept();
  },
  methods: {
    handleSubmit(e) {
      var this_ = this;
      if (e) e.preventDefault();
      if (this.errorM || this.errorU) {
        this_.$emit("callbackErr");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err || (this.currdata.code && Object.keys(err).join('') == 'code')) {
          let data = values;
          if (this.currdata.code) {
            data.createTime = this.currdata.create_time;
            data.accreditSatus = this.currdata.accredit_status;
            this.axios.post("web/emp/updateEmp", data).then(() => {
              this_.$emit("callback");
              this.$message.success("修改成功!")
            });
          } else {
            this.axios.post("web/emp/addEmp", data).then(() => {
              this_.$emit("callback");
              this.$message.success("添加成功!")
            });
          }
        } else {
          this_.$emit("callbackErr");
        }
      }).catch((e) => {
        console.log('error', e);
      });

    },
    //获取下级部门
    getXjDept(sjDeptCode) {
      this.deptList = {};
      // console.log("上级code：" + sjDeptCode)
      if (sjDeptCode != null && sjDeptCode != "") {
        this.axios.get("web/department/getXjDeptList", { params: { sjDeptCode: sjDeptCode } }).then((res) => {
          this.deptList = res.data;
        });
      }
    },
    //手机号验证
    mobileFocus() {
      let mobile = this.form.getFieldValue('telNum');
      if (!mobile) {
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(mobile)) {
        return;
      }
    },
    mobileValidator(rule, value, callback) {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback()
      }
    },
    //身份证号验证
    isValidIdNumber(rule, value, callback) {
      // 简单的身份证校验规则，可以根据实际需求进行扩展
      // const pattern = /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
      // let idCard = this.form.getFieldValue('idCard');
      if (!/^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/.test(value)) {
        callback(new Error("身份证格式错误！"));
      } else {
        callback();
      }
    }

  },
  destroyed() {
    bus.$off("ModalSubmitStaff");// 销毁 公共模块的事件监听
  },
};
</script>